import React from "react";

const Modal = ({ open, onClose, title, children }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">

      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* MODAL BOX */}
      <div className="relative bg-white w-[95%] max-w-7xl max-h-[90vh]
        rounded-2xl shadow-xl flex flex-col overflow-hidden">

        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-4
          border-b border-slate-200 bg-slate-50">
          <h2 className="text-lg font-bold">{title}</h2>

          <button
            onClick={onClose}
            className="text-2xl text-slate-500 hover:text-red-600"
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="p-4 overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
